import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  mailchimp: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& #mc_embed_signup form': {
      textAlign: 'left',
    },
    '& #mc_embed_signup': {
      width: '100%',
    },
    '& #text': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& #submit-form': {
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        marginTop: '20px',
        flexDirection: 'column',
      },
    },
    '& button': {
      borderRadius: '5px',
      fontFamily: 'Space Grotesk',
      height: '64px',
      fontSize: '18px',
      fontWeight: 'bold',
      border: 0,
      width: '128px',
      marginLeft: '10px',
      letterSpacing: '0.5px',
      lineHeight: 1.3,
      boxShadow: 'none',
      '&:hover': {
        cursor: 'pointer',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        marginLeft: 0,
        marginTop: '10px',
        height: '50px',
      },
    },
    '& #mc_embed_signup .email': {
      fontFamily: 'Inter',
      width: '450px',
      height: '64px',
      backgroundColor: 'transparent',
      color: theme.palette.text.secondary,
      lineHeight: '100%',
      '&::placeholder': {
        color: 'white',
        opacity: 0.5,
        fontSize: '24px',
        paddingLeft: '10px',
      },
      [theme.breakpoints.down('xs')]: {
        height: '50px !important',
        width: '100%',
      },
    },
    '& #mc_embed_signup #title': {
      marginTop: '20px',
      fontFamily: 'Space Grotesk',
      fontSize: '24px',
      color: 'white',
      width: '250px',
      height: '40px',
      padding: 0,
    },
    '& #mc_embed_signup #subtitle': {
      marginTop: 0,
      fontFamily: 'Inter',
      color: 'white',
      fontSize: '18px',
      fontWeight: 400,
      marginBottom: '20px',
      lineHeight: '1.5',
      [theme.breakpoints.down('xs')]: {
        // display: 'none',
        // width: '250px',
        marginBottom: 0,
      },
    },
  },
  purple: {
    '& button': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    '& #mc_embed_signup .email': {
      color: 'white',
      border: `1px solid ${theme.palette.secondary.main}`,
      height: '64px',
      padding: '10px',
      fontSize: '18px',
      borderRadius: '5px',
      '&::placeholder': {
        color: 'white',
      },
    },
    '& #mc_embed_signup #title': {
      color: 'white',
    },
    '& #mc_embed_signup #subtitle': {
      color: 'white',
    },
  },
}))

const html = `
<!-- Begin Mailchimp Signup Form -->
<div id="mc_embed_signup">
  <form action="https://cryptotesters.us5.list-manage.com/subscribe/post?u=9d2e71b5212683bbc185a6c33&amp;id=4c19550097" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
      <div id="text">
        <label id="subtitle">Add your email below to get the exclusive sign-up link sent to your email.</label>
      </div>
      <div id="submit-form">
        <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Please enter your e-mail" required>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input type="text" name="b_9d2e71b5212683bbc185a6c33_4c19550097" tabindex="-1" value="">
          </div>
          <div class="clear"><button type="submit" name="subscribe">SUBMIT</button></div>
      </div>
    </div>
  </form>
</div>
<!--End mc_embed_signup-->
`

export default function MailChimp(): JSX.Element {
  const classes = useStyles({})

  return (
    <div
      className={`${classes.mailchimp} ${classes.purple}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
